<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-demo"
    mode="horizontal"
    background-color="#409EFF"
    text-color="#fff"
    active-text-color="#fff"
    :router="true"
  >
    <el-menu-item index="1" :route="{ name: 'home' }">
      <img class="logo-image" src="../../assets/logo.svg" alt="Обазривко" />
    </el-menu-item>

    <!-- <el-submenu index="2">
        <template slot="title">Старт</template>
        <el-menu-item
          index="2"
          :route="{ name: 'guide', params: { number: 1 }}"
          v-if="user"
        >Старт</el-menu-item>
        <el-menu-item index="2-2">item two</el-menu-item>
        <el-menu-item index="2-3">item three</el-menu-item>
        <el-submenu index="2-4">
        <template slot="title">item four</template>
        <el-menu-item index="2-4-1">item one</el-menu-item>
        <el-menu-item index="2-4-2">item two</el-menu-item>
        <el-menu-item index="2-4-3">item three</el-menu-item>
        </el-submenu>
    </el-submenu>
    <el-menu-item
      index="3"
      :route="{ name: 'contact' }"
    >
    Контакт
    </el-menu-item> -->

    <el-menu-item
      index="2"
      :route="{ name: 'login' }"
      :style="{ float: 'right' }"
      v-if="!user"
    >
      Пријави се
    </el-menu-item>

    <el-menu-item :style="{ float: 'right' }" v-else>
      <el-dropdown
        @command="handleDropdownCommand"
        trigger="click"
        class="hamburger-btn"
      >
        <span class="el-dropdown-link">
          <i class="el-icon-burger"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="goToAppGuidePage" class="info-btn">
            <i class="el-icon-info"></i>
            Корисничко упутство
          </el-dropdown-item>

          <el-dropdown-item command="logout" class="exit-btn">
            <i class="el-icon-warning"></i>
            Одјави се
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  HOME_PAGE,
  LOGIN_PAGE,
} from "./../../routes/routes";

const ROUTES_INDEXES = {
  [HOME_PAGE]: "1",
  [LOGIN_PAGE]: "2",
};

export default {
  data() {
    return {
      activeIndex: "1",
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  methods: {
    ...mapActions({
      logout: "logout",
    }),
    goToAppGuidePage() {
      this.$router.push({ name: "application-guide" });
    },
    handleDropdownCommand(command) {
      this[command]();
    },
  },
  mounted() {
    this.$router.afterHooks.push((state) => {
      this.activeIndex = ROUTES_INDEXES[state.name];
    });
  },
};
</script>

<style lang="scss">
/* ----------------------------------------------
 * Generated by Animista on 2019-7-6 19:55:16
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation jello-horizontal
 * ----------------------------------------
 */
@-webkit-keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.logo-image {
  width: 10rem;
  @media screen and (max-width: 600px) {
    width: 9.5rem;
  }
  background: #ebf7ff;

  &:hover {
    background: rgb(253, 240, 18);
    -webkit-animation: jello-horizontal 0.9s both;
    animation: jello-horizontal 0.9s both;
  }
}

.hamburger-btn {
  .el-icon-burger {
    font-size: 2rem !important;
    color: #fff !important;
  }

  &:hover {
    .el-icon-burger {
      color: rgb(253, 240, 18) !important;
      transform: scale(1.2);
    }
  }
}

.exit-btn {
  color: #cc3434 !important;
}
</style>
